import { useState } from 'react';

export const Convertimageurl = () => {
    const [address, setAddress]       = useState('');
    const [embedUrl, setEmbedUrl]     = useState('');
    const [error, setError]           = useState('');
  
    const handleConvert = async () => {
        setError('');
        setEmbedUrl('');
      
        if (!address.trim()) {
          setError('Please enter a valid address or place name');
          return;
        }
      
        try {
          const res = await fetch('http://localhost:5001/api/osmEmbed', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ address: address.trim() }),
          });
      
          // Log the response body before parsing
          const text = await res.text(); // Use text() to see the raw response body
          console.log(text); // This will show the raw response (HTML error page, etc.)
      
          const json = JSON.parse(text); // Try parsing it as JSON manually
          if (!res.ok) throw new Error(json.error || 'Failed to generate URL');
          setEmbedUrl(json.embedUrl);
        } catch (e) {
          setError(e.message);
        }
      };
      

  return (
    
    <div style={{ maxWidth: 600, margin: 'auto' }}>
      <div>
        <label>
          Address or Place Name:{' '}
          <input
            type="text"
            value={address}
            onChange={e => setAddress(e.target.value)}
            placeholder="e.g. Stone and Acres Padappai"
          />
        </label>
        <button onClick={handleConvert} style={{ marginLeft: 12 }}>
          Show Map
        </button>
      </div>

      {error && <p style={{ color: 'red' }}>{error}</p>}

      {embedUrl && (
        <iframe
          title="OSM Embedded Map"
          src={embedUrl}
          width="100%"
          height="400"
          style={{ border: 0, marginTop: 16 }}
          loading="lazy"
        />
      )}
    </div>
      )
}
